<div
  class="frame-parent"
  *ngIf="content"
  [ngClass]="{
    'frame-parent': isNotParkingOrOwnershipChange(),
    'frame-parent-v2': !isNotParkingOrOwnershipChange()
  }"
>
  <div class="frame-group">
    <div class="title-parent">
      <div class="title">
        <div class="title-top">{{ content.title | translate }}</div>
      </div>
      <div class="tag">
        <img class="custom-icons" alt="" src="assets/icons/clock-icon.svg" />
        <div class="text">
          {{ "to-consult" | translate }}
        </div>
        <img src="assets/icons/cash-icon.svg" class="to-consult-price-icon" />
        <span>{{ totalOrderAmount }}€</span>
      </div>
    </div>
    <div class="llevamos-tu-vehculo">
      {{ content.description | translate }}
    </div>
    <div class="icon-and-help-text">
      <div class="icon-and-help-text1">
        <img
          class="iconssolidshield-exclamation"
          alt=""
          src="assets/icons/shield-exclamation.svg"
        />
        <div class="lorem-ipsum-dolor-sit-amet-co-wrapper">
          <div class="lorem-ipsum-dolor">
            {{ 'valet-disclaimer' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="title-group">
    <div class="title">
      <div class="title1">{{ "how-does-it-work" | translate }}</div>
    </div>
    <div class="tag-parent">
      <div class="tag1" *ngFor="let item of content.howItWorks">
        <img
          class="iconsoutlinecheck-circle"
          [src]="'assets/icons/' + item.icon + '.svg'"
        />
        <div class="text1">
          {{ item.text | translate }}
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isNotParkingOrOwnershipChange()">
    <div class="seguro">
      <div class="text4">
        <img class="logo-icon" alt="" src="assets/icons/mapfre-logo.svg" />
        <div class="card-title-parent">
          <div class="card-title">
            <div class="card-title1">{{ "breathe-easy" | translate }}</div>
          </div>
          <div class="card-title">
            <div class="descripcin">
              {{ "breathe-easy-text" | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="requisitos">
      <div class="title">
        <div class="requisitos-title">
          {{ "requirements-for-solicitude" | translate }}
        </div>
      </div>
      <div class="tag-parent">
        <div class="tag1" *ngFor="let item of content.requirements">
          <img
            class="iconsoutlinecheck-circle"
            [src]="'assets/icons/' + item.icon + '.svg'"
          />
          <div class="text1">
            {{ item.text | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="legal-text">
      <div class="lorem-ipsum">
        <span [innerHTML]="'legal-text' | translate"></span>
      </div>
    </div>
  </div>
  <div class="title-container" *ngIf="isNotParkingOrOwnershipChange()">
    <div class="title6">
      <div class="title7">{{ "service-price" | translate }}</div>
    </div>
    <div class="instance-wrapper">
      <div class="price-wrapper">
        <div class="price">{{ totalOrderAmount }}€</div>
      </div>
    </div>
  </div>
  <div class="button-container">
    <ng-content select="[left-button]"></ng-content>

    <button class="continue-button2" (click)="submitForm()">
      {{ "continue" | translate }}
    </button>
  </div>
</div>
